import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { FollowUpApplicationForm } from '@/follow-up-applications/FollowUpApplicationForm';

/**
 * Gravity Form 14, *Follow-Up Partner Application* — the coordinator form's twin,
 * differing on exactly four measured axes, all of which live in
 * `follow-up-applications/roles.ts`.
 *
 * Public and unauthenticated (L1); the routeId is on `useAuthCheck`'s
 * exact-equality allowlist for the same reason the coordinator route is.
 *
 * NOT the same thing as GF 13 (`/follow-up-partners` Add Partner, W4.8): that
 * one is a coordinator registering somebody and mints an `unverified` partner
 * with `created_by` set, where an approved application here mints a VERIFIED
 * partner with no creator and no network edge (DIV-25, L18).
 */
export const Route = createFileRoute('/follow-up-partner-application')({
  component: FollowUpPartnerApplicationPage,
  beforeLoad: () => {
    return {
      pageBackground: 'white',
      noContainer: true,
    };
  },
});

function FollowUpPartnerApplicationPage(): ReactElement {
  return <FollowUpApplicationForm applicationRole="partner" />;
}
